import axios from "axios";
import adminApi from "../axios";
import { v1BaseUrl } from "./apiBaseUrl";

const v1Api = axios.create({ baseURL: v1BaseUrl });
const authConfig = (extra = {}) => ({
  ...extra,
  headers: { ...extra.headers, Authorization: `Bearer ${localStorage.getItem("@token")}` },
});

const dataOf = (response) => response?.data?.data ?? response?.data ?? [];

export async function listClassAssignments(classId) {
  const rows = dataOf(await v1Api.get(`classes/${classId}/notes`, authConfig()));
  return (Array.isArray(rows) ? rows : []).filter((note) => note.note_type === "ASSIGNMENT");
}

export async function listCategories() {
  const rows = dataOf(await adminApi.get("category", authConfig()));
  return Array.isArray(rows) ? rows : [];
}

export async function createClassAssignment(classId, guruId, payload) {
  const created = await v1Api.post("notes", {
    title: payload.title,
    description: payload.description || "",
    creator_id: Number(guruId),
    category_id: Number(payload.category_id),
    video_link: payload.video_link || null,
    audio_link: [],
    image_link: [],
    note_link: [],
  }, authConfig());
  const noteId = created.data?.note_id ?? created.data?.data?.note_id;
  if (!noteId) throw new Error("Assignment note was created without an ID");
  await v1Api.post(`classes/${classId}/notes`, {
    note_id: Number(noteId),
    note_type: "ASSIGNMENT",
  }, authConfig());
  return noteId;
}

export async function listAssignmentSubmissions(assignmentId) {
  const rows = dataOf(await v1Api.get(`notes/${assignmentId}/submissions`, authConfig()));
  return Array.isArray(rows) ? rows : [];
}

export async function reviewAssignmentSubmission(submissionId, payload) {
  return dataOf(await v1Api.patch(`notes/${submissionId}/review`, payload, authConfig()));
}
